/**
 * TODO
 *  after update the app to React v18, use the `useId` hook to generate a id
 * to be the key of options in the store.
 */
import PropTypes from 'prop-types';
import { cloneElement, useEffect, useMemo } from 'react';

import Text from '../Text';
import { StyledList } from './AutoCompleteContainer';
import { useAutoComplete } from './Context/AutoCompleteProvider';

function AutoCompleteList({ options = [], render, title, ...rest }) {
  const { maxOptions, optionsValuesStore, optionsMapper } = useAutoComplete();

  const internalOptions = useMemo(() => {
    if (options.length === 0) {
      return [];
    }

    return optionsMapper(options, maxOptions.getter);
  }, [options]);

  useEffect(() => {
    const optionsValues = internalOptions.map(({ value }) => value);

    optionsValuesStore.setter((prevState) => ({
      ...prevState,
      [title]: optionsValues,
    }));

    return () => {
      optionsValuesStore.setter((prevState) => {
        delete prevState[title];

        return prevState;
      });
    };
  }, [internalOptions]);

  if (internalOptions.length === 0) {
    return null;
  }

  return (
    <StyledList {...rest}>
      {title && (
        <Text size="size3" py={3} px={4} upper>
          {title}
        </Text>
      )}
      {/* TODO in future this can be improved */}
      {internalOptions.map(({ text, value, ...props }) =>
        cloneElement(render({ text, ...props }), {
          key: value,
          value,
        })
      )}
    </StyledList>
  );
}

AutoCompleteList.defaultProps = {
  maxOptions: null,
  title: null,
};

AutoCompleteList.propTypes = {
  /**
   * Set the max quantity of options that will be render
   */
  maxOptions: PropTypes.number,
  /**
   * Set the options that will be render
   */
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ])
  ),
  /**
   * Callback fn used to render each autocomplete option
   */
  render: PropTypes.func.isRequired,
  /**
   * Set the list section title
   *
   * obs: when the app isn't updated to React v18, don't use this prop as a
   * dynamic value
   */
  title: PropTypes.string,
};

export default AutoCompleteList;
